/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Edit
 */
export interface Edit {
  /**
   *
   * @type {string}
   * @memberof Edit
   */
  guid: string;
  /**
   *
   * @type {number}
   * @memberof Edit
   */
  goalType: number;
  /**
   *
   * @type {Array<string>}
   * @memberof Edit
   */
  stepData: Array<string>;
  /**
   *
   * @type {string}
   * @memberof Edit
   */
  changes: string;
  /**
   *
   * @type {string}
   * @memberof Edit
   */
  modified?: string | null;
}
